import { MdAccountCircle, MdNotifications } from 'react-icons/md';
import { CgMenuGridR } from 'react-icons/cg';
// import { BsMoonStarsFill, BsMoonStars } from 'react-icons/bs';
import { NavLink } from 'react-router-dom';
import Logo from '../Assets/Image/Logo.png';
import { useState } from 'react';
import { ProfileCard } from '../Profile/ProfileCard';
import { NotificationCard } from '../Notifications/NotificationCard';
import { useNotifications } from '../Hooks/useNotifications';

function TradeNavBar({ setShowNav }) {
  // const [displayMoonIcon, setDisplayMoonIcon] = useState(true);
  const [profileCardHover, setProfileCardHover] = useState(true);
  const [notificationHover, setNotificationHover] = useState(true);

  // const handleClick = () => {
  //   setDisplayMoonIcon(() => {
  //     return !displayMoonIcon;
  //   });
  // };

  const handleAddProfileCard = () => {
    setProfileCardHover(!profileCardHover);
  };

  const handleNotificationCard = () => {
    setNotificationHover(!notificationHover);
  };

  const { newNotifications } = useNotifications();

  return (
    <div className=''>
      <nav className='flex flex-row mx-auto gap-26 items-center justify-between drop-shadow-lg bg-p-wh px-4 py-3'>
        <div className='flex flex-row items-center gap-[2rem] lg:gap-[10.4rem]'>
          <NavLink
            to='/dashboard'
            className='text-b-mc font-semibold flex flex-row items-center gap-2'
          >
            <img src={Logo} alt='Loyaltyview Logo' className='w-6' />
            <span>Loyaltyview</span>
          </NavLink>
          <button
            onClick={() => setShowNav((show) => !show)}
            className='text-p-bk text-2xl font-semibold block lg:hidden'
          >
            <CgMenuGridR />
          </button>
        </div>
        <div className='flex flex-row items-center '>
          <div
            className='py-2 px-4 text-2xl relative cursor-pointer'
            onClick={handleNotificationCard}
          >
            <MdNotifications />
            <span className='bg-red-500 text-[10px] right-2 rounded-full w-5 h-5 text-p-wh absolute top-0 text-center flex items-center justify-center'>
              {newNotifications.length}
            </span>
          </div>
          <div
            className='py-2 px-4 text-2xl cursor-pointer'
            onClick={handleAddProfileCard}
          >
            <MdAccountCircle />
            {/* <img src={payload.user.profile_picture} alt="profile picture" /> */}
          </div>
          {/* <div className='py-2 px-4 text-lg cursor-pointer'>
            {!displayMoonIcon ? (
              <BsMoonStarsFill onClick={handleClick} />
            ) : (
              <BsMoonStars onClick={handleClick} />
            )}
          </div> */}
        </div>
      </nav>
      {profileCardHover ? null : (
        <div
          className='absolute right-6 top-8 pt-10 min-w-[14rem] cursor-pointer'
          onMouseLeave={handleAddProfileCard}
        >
          <ProfileCard />
        </div>
      )}
      {notificationHover ? null : (
        <div
          className='absolute right-6 top-8 pt-10 min-w-[14rem] cursor-pointer'
          onMouseLeave={handleNotificationCard}
        >
          <NotificationCard />
        </div>
      )}
    </div>
  );
}
export default TradeNavBar;
